import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "attribute-selector" },
    [
      _c(VAutocomplete, {
        ref: "autocomplete",
        attrs: {
          items: _vm.availableAttributeItems,
          label: _vm.$t("attributes.filters.filterByAttributes"),
          loading: _vm.loading,
          "item-text": "text",
          "item-value": "value",
          chips: "",
          "small-chips": "",
          multiple: "",
          "deletable-chips": "",
          counter: _vm.maxSelections,
          rules: [_vm.limitRule],
          "item-disabled": _vm.isItemDisabled,
        },
        on: { change: _vm.onChange },
        model: {
          value: _vm.selectedKeys,
          callback: function ($$v) {
            _vm.selectedKeys = $$v
          },
          expression: "selectedKeys",
        },
      }),
      _vm._v(" "),
      _vm.selectionError
        ? _c("div", { staticClass: "error--text text-caption mt-1" }, [
            _vm._v("\n    " + _vm._s(_vm.selectionError) + "\n  "),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }